define((require) => {
    "use strict";

    const InfiniteScrollingCollectionView = require("ui/common/InfiniteScrollingCollectionView");
    const NoResultsItemView               = require("zbone/NoResultsItemView");
    const ImageExperienceItemView         = require("ui/imageLibrary/ImageExperienceItemView.js");
    const template                        = require("ui/imageLibrary/ImageExperienceCompositeView.tpl");

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) image experiences, i.e. <tt>ImageExperienceItemView</tt>'s.
     *
     * @cfg {ImageExperienceCollection} collection The <tt>ImageExperienceCollection</tt> to render.
     *
     * @see  ImageDetailsView
     * @see  ImageExperienceItemView
     * @see  InfiniteScrollingCollectionView
     *
     * @class ImageExperienceCompositeView
     */
    return InfiniteScrollingCollectionView.extend("ImageExperienceCompositeView", {

        tagName: "table",

        className: "infinite-container experiences-list table",

        template: template,

        itemViewContainer: "tbody",

        itemView: ImageExperienceItemView,

        spinnerContainer: ".experiences-loading",

        onEmpty() {
            return new NoResultsItemView({type: "Experiences"});
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/ImageExperienceCompositeView.js